// src/api/resource/resource.api.js

import { publicClient } from "../../config/axiosConfig";

const resourceEndpoints = {
  requestDownload: "v2/resources/request-download",
};

const resourceApi = {
  requestDownload: async ({
    email,
    resourceSlug,
    marketingConsent = false,
  }) => {
    try {
      const response = await publicClient.post(
        resourceEndpoints.requestDownload,
        {
          email,
          resourceSlug,
          marketingConsent,
        },
      );

      return { response };
    } catch (err) {
      console.error("Error requesting resource download:", err);
      return { err };
    }
  },
};

export default resourceApi;
